import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Features() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            赛事资讯中心
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            无论您是新手还是资深玩家，这里都有您需要的Yandex每日大赛相关信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-3 flex items-center gap-1 text-xs text-primary-600 font-medium">
                <span>了解更多</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}